import { render, staticRenderFns } from "./BaseTopNavigatorBar.vue?vue&type=template&id=05db39ba&scoped=true&"
import script from "./BaseTopNavigatorBar.vue?vue&type=script&lang=ts&"
export * from "./BaseTopNavigatorBar.vue?vue&type=script&lang=ts&"
import style0 from "./BaseTopNavigatorBar.vue?vue&type=style&index=0&id=05db39ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05db39ba",
  null
  
)

export default component.exports